import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import LabelledInput from 'Components/Form/LabelledInput';
import Error from 'Components/Form/Error';

import { sendResetPasswordCode } from 'cognito/auth';

const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2-4}$/;

function RequestPasswordReset ()
{
    const navigate = useNavigate ();

    const [ email, setEmail ] = useState ( localStorage.getItem ( "email" ) ? localStorage.getItem ( "email" ) : "" );
    const [ isLoading, setIsLoading ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );
    const [ isInputValid, setIsInputValid ] = useState ( false );

    const doRequestCode = async () =>
    {
        setError ( { isError: false, message: null } );
        setIsLoading ( true );
        localStorage.setItem ( "email", email );

        try
        {
            const result = await sendResetPasswordCode ( email );
            console.log ( result );

            if ( result.nextStep.resetPasswordStep === "CONFIRM_RESET_PASSWORD_WITH_CODE" )
            {
                setError ( { isError: false, message: null } );
                setIsLoading ( false );

                navigate ( '/participant/passwordreset' );
            }
            else
            {
                setIsLoading ( false );
                setError ( { isError: true, message: "Unsupported next step: " + JSON.stringify ( result.nextStep ) } );
            }
        }
        catch ( error )
        {
            if ( error.name === "UserNotFoundException" )
            {
                setError ( { isError: false, message: null } );
                setIsLoading ( false );

                navigate ( '/participant/passwordreset' );
            }
            else
            {
                setError ( { isError: true, message: JSON.stringify ( error ) } );
                setIsLoading ( false );
            }
        }
    }

    const updateInput = ( email ) =>
    {
        setEmail ( email );
        setIsInputValid ( EMAIL_PATTERN.test ( email ) );
    }

    return  <div className="w-full sm:w-4/6 md:w-3/6 m-auto">
                <h1>Reset Password</h1>
                <p className="mb-4">Enter your email address to receive a code to reset your password.</p>
                <form>
                    { error.isError && <Error message={error.message} /> }
                    <LabelledInput id="email" label="Email" value={email} onChange={ ( newValue ) => updateInput ( newValue ) } type="email" />
                    <div className="flex-row gap-8">
                        <button onClick={ () => doRequestCode () } disabled={ isInputValid || isLoading } type="submit">Request Code</button>
                        <Link to="/participant/register">Register a New Account</Link>
                    </div>
                </form>
            </div>
}

export default RequestPasswordReset;